module.exports = __webpack_public_path__ + "static/img/041_TO8_1538.c59cd5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/041_TO8_1538.jpg
// module id = sLrt
// module chunks = 0